import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

import bg1 from '../assets/images/bg/bg-lines-one.png'
import logoDark from '../assets/images/logo-dark.png'

import {FiHome} from '../assets/icons/vander'
// eslint-disable-next-line no-unused-vars
import {SlSocialGoogle } from '../assets/icons/vander'
// eslint-disable-next-line no-unused-vars
import {FaSquareFacebook} from 'react-icons/fa6'

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useContext(require("../context/AuthContext").AuthContext);

    const validate = () => {
        if (!email || !password) {
            setError("Email and password are required.");
            return false;
        }
        // Simple email regex
        if (!/^\S+@\S+\.\S+$/.test(email)) {
            setError("Please enter a valid email address.");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (!validate()) return;
        setLoading(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/users/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password })
            });
            const data = await res.json();
            if (!res.ok) {
                setError(data.message || "Login failed.");
                setLoading(false);
                return;
            }
            const userObj = { userId: data.userId, role: data.role };
            login(userObj, data.token);
            if (data.role === "admin") {
                navigate("/dashboard");
            } else if (data.role === "doctor") {
                navigate("/doctor-dashboard");
            } else {
                navigate("/");
            }
        } catch (err) {
            setError("Network error. Please try again.");
        }
        setLoading(false);
    };

        return (
            <>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'rgba(255,255,255,0.7)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <div className="spinner-border text-primary" style={{width: '3rem', height: '3rem'}} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
                <div className="back-to-home rounded d-none d-sm-block">
                    <Link to="/" className="btn btn-icon btn-primary"><FiHome className="icons" /></Link>
                </div>
                <section className="bg-home d-flex bg-light align-items-center" style={{ backgroundImage: `url(${bg1})`, backgroundPosition: 'center' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-5 col-md-8">
                                <img src={logoDark} height="22" className="mx-auto d-block" alt="" />
                                <div className="card login-page shadow mt-4 rounded border-0">
                                    <div className="card-body">
                                        <h4 className="text-center">Sign In</h4>
                                        <form className="login-form mt-4" onSubmit={handleSubmit} autoComplete="off">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                                        <input type="email" className="form-control" placeholder="Email" name="email" value={email} onChange={e => setEmail(e.target.value)} required />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Password <span className="text-danger">*</span></label>
                                                        <input type="password" className="form-control" placeholder="Password" name="password" value={password} onChange={e => setPassword(e.target.value)} required />
                                                    </div>
                                                </div>
                                                {error && (
                                                    <div className="col-lg-12">
                                                        <div className="alert alert-danger py-2">{error}</div>
                                                    </div>
                                                )}
                                                <div className="col-lg-12 mb-0">
                                                    <div className="d-grid">
                                                        <button className="btn btn-primary" type="submit" disabled={loading}>{loading ? "Signing in..." : "Sign in"}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
}